import { createI18n } from "vue-i18n"

import en from "@/i18n/locales/en.json"
import de from "@/i18n/locales/de.json"
import es from "@/i18n/locales/es.json"
import fr from "@/i18n/locales/fr.json"
import zh from "@/i18n/locales/zh.json"
import ja from "@/i18n/locales/ja.json"

// Locale support is an app-level constant, not a per-deployment config value.
export const DEFAULT_LOCALE = "en"
export const FALLBACK_LOCALE = "en"
export const SUPPORTED_LOCALES = ["en", "de", "es", "fr", "zh", "ja"]

const i18n = createI18n({
  locale: DEFAULT_LOCALE,
  fallbackLocale: FALLBACK_LOCALE,
  legacy: false,
  availableLocales: SUPPORTED_LOCALES,
  messages: {
    en,
    de,
    es,
    fr,
    zh,
    ja,
  },
});

export default i18n;
